import { useEffect, useState } from "react";
import { api, ApiError, type AgentMe } from "./api.ts";
import { Login } from "./Login.tsx";
import { WidgetHost } from "./WidgetHost.tsx";

const TOKEN_KEY = "pickit-voip:token";

export function App() {
  const [token, setToken] = useState<string | null>(() => localStorage.getItem(TOKEN_KEY));
  const [me, setMe] = useState<AgentMe | null>(null);
  const [bootError, setBootError] = useState<string | null>(null);

  useEffect(() => {
    if (!token) {
      setMe(null);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const data = await api.me(token);
        if (!cancelled) setMe(data);
      } catch (err) {
        if (cancelled) return;
        if (err instanceof ApiError && err.status === 401) {
          localStorage.removeItem(TOKEN_KEY);
          setToken(null);
          setMe(null);
        } else {
          setBootError((err as Error).message);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  function handleLogin(newToken: string): void {
    localStorage.setItem(TOKEN_KEY, newToken);
    setToken(newToken);
    setBootError(null);
  }
  function handleLogout(): void {
    localStorage.removeItem(TOKEN_KEY);
    setToken(null);
    setMe(null);
  }

  if (!token) {
    return (
      <div className="app-shell--full">
        <Login onLogin={handleLogin} />
      </div>
    );
  }
  if (bootError) {
    return (
      <div className="app-shell--full">
        <div className="login-card">
          <h1 className="brand">Pickit<span className="accent">VoIP</span></h1>
          <div className="toast error">{bootError}</div>
          <button className="primary" onClick={handleLogout}>Sign out</button>
        </div>
      </div>
    );
  }
  if (!me) {
    return (
      <div className="app-shell--full">
        <p className="muted">Loading agent profile…</p>
      </div>
    );
  }
  return <WidgetHost me={me} token={token} onLogout={handleLogout} />;
}
